import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaRegCopy } from 'react-icons/fa';
import frame from '../../../assets/Images/Frame 80.png';
import { FcGoogle } from "react-icons/fc";
// import { FaArrowRight } from "react-icons/fa6";
import mail from '../../../assets/Images/e4af9f03c1c25f9c19636b2b8694d05dcf891227.png';
import { FaCheckCircle } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import './MultiFactor.scss'

function MultiFactor() {

  const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;
      
  const [qrCodeImageUrl, setQrCodeImageUrl] = useState('');
  const [secret, setSecret] = useState('');
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');
  const [recoveryCode, setRecoveryCode] = useState('');
  const [showRecoveryCodeOnly, setShowRecoveryCodeOnly] = useState(false);
  const [selectedAuth, setSelectedAuth] = useState('google');
   const [copied, setCopied] = useState(false);
   const navigate = useNavigate("")


  useEffect(() => {
    const fetchQrCode = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await axios.get(`${baseURL}/api/auth`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setQrCodeImageUrl(response.data.qrCodeImageUrl);
        setSecret(response.data.secret);
      } catch (error) {
        console.error('Error fetching QR code:', error);
      }
    };

    fetchQrCode();
  }, []);

  const handleVerify = async () => {
    try {
      const authToken = localStorage.getItem('token');
      const response = await axios.post(
        `${baseURL}/api/verify`,
        { token },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setMessage(response.data.message);

      if (response.data.recoveryCode) {
        setRecoveryCode(response.data.recoveryCode);
        setShowRecoveryCodeOnly(true)
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Verification failed');
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(recoveryCode);
     Swal.fire({
            icon: "Copied",
            title: "Copied Recovery Code",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
  };

  const handleSecret = () => {
    navigator.clipboard.writeText(secret).then(() => {
      setCopied(true);
       Swal.fire({
            icon: "Copied",
            title: "Copied Secret Code",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
      
    });
  };

  return (
    <>
    <div>
        <img src={frame} alt="frame" width="100%" />
    </div>
   <div className="multi-header-container">
  <div className="multi-title">MULTI FACTOR AUTHENTICATION</div>
  <div className="multi-back-wrapper">
    <button className="multi-back-btn" onClick={() => navigate("/userprofile")}>
     <IoMdArrowRoundBack  /> Back 
    </button>
  </div>
</div>

      <div className='multi-factor'>
        <div className='multi-auth'>
          <div className='google-auth'  onClick={() => setSelectedAuth('google')}
  style={{
    border: selectedAuth === 'google' ? '3px solid #EEB61F' : '5px solid transparent',
  }}>
           <div className='google'>Google Authenticator</div>
           <div className='two-fac'>Use any one of the two-factor app on your device</div>
          <div style={{display:"flex", justifyContent:"space-between"}}>
           <div className='google-authenicator'>
            <div className='google-icon'>
              <FcGoogle />
            </div>
            <div className='add-google'>
              Add Google Authenticator
            </div>
              <div style={{ color: message.includes('success') ? 'green' : 'red', width:"100%", marginLeft:"220px",marginTop:"2px", fontSize:"15px", fontWeight:"700" }}>
            {message}
          </div> 
          <div>
            <FaArrowRight style={{marginTop:"5px", fontSize:"15px"}} />
          </div>
           </div>
          
          </div>
          
         </div>
           <div style={{marginTop:"20px",  border: selectedAuth === 'email' ? '3px solid #EEB61F' : '5px solid transparent',}} className='google-auth' onClick={() => setSelectedAuth('email')}>
           <div className='google'>Email Authenticator</div>
           <div className='two-fac'>Use your email to generate one time security codes</div>
          <div style={{display:"flex", justifyContent:"space-between"}}>
           <div className='google-authenicator'>
            <div className='google-icon'>
              <img src={mail} alt="mail" width="30px" />
            </div>
            <div className='add-google'>
              Add Mail
            </div>
            <div>
            <FaArrowRight style={{marginTop:"5px", fontSize:"15px"}} />
          </div>
           </div>
          </div>
          
         </div> 
        </div>
        <div className='verification'>
    {qrCodeImageUrl ? (
  <>
    {!showRecoveryCodeOnly && (
      <>
        <div className='auth-code'>Scan the Code into your Google Authenticator app</div>
        <img
         src={qrCodeImageUrl}
          alt="Scan QR code"
          style={{ marginBottom: '1rem', marginTop: "20px" }}
        />
        <p>Secret key: <strong>{secret}</strong>  <FaRegCopy style={{ cursor: 'pointer' }} onClick={handleSecret} /></p>
        <div className='auth-code'>Enter the 6-Digit authentication code generated by your app.</div>
        <input className='auth-input'
          type="text"
          placeholder="Enter token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          style={{ padding: '0.5rem', marginRight: '0.5rem' }}
        />
        <br />
        <button className='verify' onClick={handleVerify}>
          Continue
        </button>
      </>
    )}

    {recoveryCode && showRecoveryCodeOnly && (
      <>
      <div style={{color:"#46B53C", fontSize:"15px", fontWeight:"700", display:"flex",flexDirection:"row" , gap:"5px"
}}> <div><FaCheckCircle style={{marginTop:"2px"}} /></div>
<div>Successfully enabled</div> </div>


      <div style={{
        borderRadius: '8px',
        padding: '1rem',
        marginTop: '1.5rem',
        display: 'inline-block',
        backgroundColor: 'white',
        textAlign: 'left',
        width: 'fit-content'
      }}>
         <li style={{ fontSize: '0.85rem', color: '#777', marginTop: '0.5rem', marginLeft:"10px" }}>
         Save this recovery codes and store it somewhere safe.
        </li>
        <li style={{ fontSize: '0.85rem', color: '#777', marginTop: '0.5rem', marginLeft:"10px" }}>
        If you lose your device , you can backup codes to sign in. 
        </li>
        </div>
        <h3 style={{ marginBottom: '0.5rem' }}>Recovery Code</h3>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#fff',
        
          padding: '0.5rem',
          borderRadius: '4px',
          fontFamily: 'monospace',
          fontSize: '1rem'
        }}>
          <span style={{ marginRight: '0.5rem' }}>{recoveryCode}</span>
          <FaRegCopy style={{ cursor: 'pointer' }} onClick={handleCopy} />
        </div>
        <button className='verify'>
          Done
        </button>
      
   </> )}
  </>
) : (
  <p>Loading QR code...</p>
)}

      </div>
    </div>
    </>
  );
}

export default MultiFactor;